import { render, staticRenderFns } from "./Oauth.vue?vue&type=template&id=66b68127"
import script from "./Oauth.vue?vue&type=script&lang=js"
export * from "./Oauth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports